import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';
import { DataSourceConfigsState } from './data-source-configs.state';

@NgModule({
  imports: [CommonModule, NgxsModule.forFeature([DataSourceConfigsState])],
  declarations: []
})
export class DataSourceConfigsStoreModule {}
